import React, { useState, useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Button, ListGroup, Container, Row, Col, Modal, Form } from 'react-bootstrap';
import ColorPicker, { useColor } from "react-color-palette";
import "react-color-palette/lib/css/styles.css";

const Scegli_materie = (props) => {

    const [valore, set_funzione_valore] = useState();
    const [indice_materia, set_materia_scelta] = useState(0);
    const [show, setShow] = useState(false);
    const [color, setColor] = useColor("hex", "#121212");

    useEffect(() => {
        console.log('useEffect Scegli materie')
        if (props.aggiorna_lista_file_stornati) {
            //        controlla_i_dati_caricati_aggiorna_array()
            props.SET_aggiorna_lista_file_stornati(false)
            crea_lista_stornati()
        }
    }, [props.aggiorna_lista_file_stornati]);


    const crea_lista_stornati = () => {
        var lista_materie_aux = props.lista_materie
        var lista_file_mp3_aux = props.lista_file_mp3
        var lista_play_aux = []
        var valore_minimo = 0
        props.lista_file_mp3.map(function (item, index2) {
            var inserito = false
            if ((parseInt(item.indice_end) - parseInt(item.indice_aux)) < valore_minimo) {
                valore_minimo = item.indice_end - item.indice_aux
                //                console.log('====>>>>> ' + valore_minimo)
            }
            var roots2 = lista_materie_aux.map(function (item2, index4) {
                if (item.materia == item2.materia && item2.attivo && !inserito) {
                    lista_file_mp3_aux[index2].colore_bordo = item2.colore_bordo
                    lista_play_aux.push(index2)
                    inserito = true
                }

                if (item.materia == 'new' && !inserito) {
                    lista_file_mp3_aux[index2].colore_bordo = 'black'
                    lista_play_aux.push(index2)
                    inserito = true
                }
            });
        });
        props.SET_valore_minimo_sottrazione(valore_minimo)
        props.SET_funzione_play_lista(lista_play_aux)
        props.SET_lista_file_mp3(lista_file_mp3_aux)
        function_swap(lista_play_aux)
    }


    const function_swap = (lista_play_aux) => {
        var play_lista_aux = lista_play_aux
        var continua = true
        while (continua) {
            continua = false
            var index1
            var index2
            var roots = play_lista_aux.map(function (item, index) {
                //        console.log('swap' + index + ' - ' + lista_file.length)
                if (index > 0) {
                    index1 = play_lista_aux[index]
                    index2 = play_lista_aux[index - 1]
                    var diff1 = props.lista_file_mp3[index1].indice_end - props.lista_file_mp3[index1].indice_aux
                    var diff2 = props.lista_file_mp3[index2].indice_end - props.lista_file_mp3[index2].indice_aux
                    if (diff1 < diff2) {
                        console.log('swap')
                        continua = true
                        var riga1 = play_lista_aux[index]
                        play_lista_aux[index] = play_lista_aux[index - 1]
                        play_lista_aux[index - 1] = riga1
                    }
                }
            });

        }
        props.SET_funzione_play_lista(play_lista_aux)
        console.log(play_lista_aux)
    }

    const alertClicked = (indice) => {
        var lista_materie_aux = props.lista_materie
        lista_materie_aux[indice].attivo = !lista_materie_aux[indice].attivo
        props.SET_lista_materie(lista_materie_aux)
        crea_lista_stornati()
        props.set_funzione_aggiorna_lista(2)
    }


    const handleChange = (event) => {
        set_funzione_valore(event.target.value)
    }

    const handleSubmit = (event) => {
        var lista_aux = props.lista_materie
        event.preventDefault();
        lista_aux.push({ materia: valore, attivo: true, colore_bordo: 'solid red' })
        props.SET_lista_materie(lista_aux)
        //        console.log(lista_aux)
        props.set_funzione_aggiorna_lista(2)
        set_funzione_valore('')
    }

    function alertClicked2() {
        alert('You clicked the third ListGroupItem');
    }

    const function_prova = (index) => {
        let lista_aux = props.lista_materie
        lista_aux.splice(index, 1)
        props.set_funzione_aggiorna_lista(2)
    }



    function colorazione(index2) {
        var colore = 'black'
        var colore_bordo = 'solid red'
        if (props.lista_materie[index2].colore_bordo != undefined) {
            colore_bordo = '3px solid ' + props.lista_materie[index2].colore_bordo
        }

        //        console.log('colore ' + props.lista_materie[index2].colore_bordo)
        var hStyle = { backgroundColor: 'lightgray', color: colore, margin: '5px', padding: '5px', border: colore_bordo, borderRadius: '2px' };
        return hStyle;
    }

    const Chiusura_della_finestra_modale = () => {
        setShow(false);
    }

    const apertura_finestra_modale = (index) => {
        set_materia_scelta(index)
        setShow(true)
    }

    const ottieni_colore = () => {
        var lista_materie_aux = props.lista_materie
        console.log(color)
        lista_materie_aux[indice_materia].colore_bordo = color.hex
        props.SET_lista_materie(lista_materie_aux)
        //        console.log(lista_aux)
        props.set_funzione_aggiorna_lista(2)
        setShow(false)
        //        setShow(false)
    }


    return (
        <div >
            <Modal
                show={show}
                onHide={Chiusura_della_finestra_modale}
                backdrop="static"
                keyboard={false}
            >
                <Modal.Header closeButton>
                    <Modal.Title>Edit</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Form.Group controlId="exampleForm.ControlTextarea1">
                            <Form.Label>Materia  {props.lista_materie[indice_materia].materia} </Form.Label>

                            <ColorPicker width={456} height={228} color={color} onChange={setColor} hideHSB dark />
                        </Form.Group>
                    </Form>

                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => Chiusura_della_finestra_modale()}>
                        Annulla
                      </Button>
                    <Button variant="primary" onClick={() => ottieni_colore()}>Salva</Button>
                </Modal.Footer>
            </Modal>

            <form onSubmit={handleSubmit}>
                <input type="text" placeholder="Nuova materia" value={valore} onChange={handleChange} />

            </form>

            <ListGroup>
                {props.lista_materie.map(function (item, index2) {
                    {
                        //                        console.log(item)
                        return <div style={colorazione(index2)}>
                            <Row>
                                <Col>
                                    <ListGroup.Item active={item.attivo} action onClick={() => alertClicked(index2)}>
                                        {item.materia}
                                    </ListGroup.Item>
                                </Col>
                                <Col>

                                    <Button variant="outline-primary" onClick={() => apertura_finestra_modale(index2)}>Modifica</Button>{' '}

                                </Col>
                            </Row>
                        </div>
                    }
                })
                }
            </ListGroup>
        </div>
    )
}
export default Scegli_materie;